export type TikTokClipBlock =
  | { kind: 'watermarked' }
  | { kind: 'too_long'; durationSeconds: number; maxDurationSeconds: number };

const isPositiveFinite = (value: number | null | undefined): value is number => (
  typeof value === 'number' && Number.isFinite(value) && value > 0
);

/**
 * Why a clip cannot be posted to TikTok, or null.
 *
 * TikTok's Content Sharing Guidelines forbid an app from adding its own
 * watermark to posted content (`watermark` is true when the free-plan
 * AutoClipper watermark was burned into the render), and require checking the
 * video's duration against the creator's `max_video_post_duration_sec`. The
 * backend enforces the watermark rule too; the duration comes from the
 * preview video, so it is unknown until its metadata loads.
 */
export function resolveTikTokClipBlock({ watermark, durationSeconds, maxDurationSeconds }: {
  watermark?: boolean | null;
  durationSeconds?: number | null;
  maxDurationSeconds?: number | null;
}): TikTokClipBlock | null {
  if (watermark === true) return { kind: 'watermarked' };
  if (
    isPositiveFinite(durationSeconds)
    && isPositiveFinite(maxDurationSeconds)
    && durationSeconds > maxDurationSeconds
  ) {
    return { kind: 'too_long', durationSeconds, maxDurationSeconds };
  }
  return null;
}
